import { useMemo } from 'react'
import { Stack, Typography, useTheme, Skeleton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { gql, useQuery } from '@apollo/client'

import { useSites, useUser } from 'store'

export const OPERATION_COUNT_ALARMS = gql`
  query VoipSIPsAlarmCount($site_sf_id: ID!) {
    count: voipSIPsAlarmCount(site_sf_id: $site_sf_id)
  } 
`

const KPIVoipAlarms = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [{selected}] = useSites()
  const [user] = useUser()
  const navigate = useNavigate()
  const hasRole = user?.admin || Boolean(user?.roles['voip'])
  const { data, loading } = useQuery(OPERATION_COUNT_ALARMS, {
    fetchPolicy: 'network-only',
    variables: {
      site_sf_id: selected[0]?.sf_id
    },
    skip: !(selected.length === 1 && hasRole)
  })
  const showKpi = useMemo(() => {
    if (selected.length > 1) {
      return false
    } else if (!hasRole) {
      return false
    } else if (!data || data.count === 0) {
      return false
    }
    return true
  }, [selected, hasRole, data])
  if (loading) {
    return (
      <Stack
        sx={{
          padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: '24px',
          color: '#000000'
        }}
      >
        <Stack direction={'row'} gap={2}>
          <Stack flexGrow={1}>
            <Skeleton width="100%" height={20} />
            <Skeleton width="100%" height={16} sx={{ mt: 0.5 }} />
          </Stack>
          <Skeleton variant="circular" width={32} height={32} sx={{alignSelf: 'center'}}/>
        </Stack>

      </Stack>
    )
  } else if (!showKpi) {
    return null
  }
  return (
    <Stack
      sx={{
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '24px',
        cursor: 'pointer',
        color: '#000000'
      }}
      onClick={() => navigate('/voip/sips')}
    >
      <Stack justifyContent="space-between" direction="row">
        <Stack gap={.25}>
          <Typography sx={{ fontSize: '14px', color: '#000000' }}>{t('voip.sip.home_kpis.subtitle')}</Typography>
          <Typography sx={{ fontSize: '11px', color: theme.palette.grey[600] }}>{t('voip.sip.home_kpis.title')}</Typography>
        </Stack>
        <Stack direction="row" alignSelf="center" alignItems="center" gap={.5}>
          <Typography sx={{ fontSize: '22px', color: '#000000' }}>{data.count}</Typography>
        </Stack>
      </Stack>

    </Stack>
  )
}

export default KPIVoipAlarms